/**
 * Brandner Profile Completion
 *
 * - 3-Schritt-Wizard (Persoenliche Daten → Telefon → Rechtliches)
 * - Echtzeit-Validierung (PLZ-Format, Pflichtfelder)
 * - AGB-Modal: Scroll-to-Bottom / Timer Pattern
 * - AJAX-Formular-Submit
 * - Erfolgs-Popup mit Auto-Redirect
 *
 * @package Brandner_Custom
 * @since 1.9.0
 */
(function($) {
    'use strict';

    var config = window.brandnerProfileCompletion || window.brandnerProfile || {};
    var agbAccepted = $('#brandner_agb_accepted').val() === '1';
    var currentStep = 1;

    // =====================================================================
    // Phone Input Sync (national input → hidden billing_phone)
    // Needed even when SMS verification is disabled
    // =====================================================================
    function initPhoneSync() {
        var $national = $('#brandner_phone_national');
        var $hidden = $('#billing_phone');
        if (!$national.length || !$hidden.length) return;

        $national.on('input change', function() {
            $hidden.val($national.val());
        });

        // Sync on init if national has a value but hidden is empty
        if ($national.val() && !$hidden.val()) {
            $hidden.val($national.val());
        }
    }

    // =====================================================================
    // Wizard
    // =====================================================================
    function initWizard() {
        var $panels = $('.brandner-wizard-panel');
        if ($panels.length < 2) return; // Fallback: kein Wizard noetig

        // Panel 2+3 initial ausblenden (JS-only — ohne JS bleiben alle sichtbar)
        $panels.filter('[data-wizard-step="2"]').hide();
        $panels.filter('[data-wizard-step="3"]').hide();

        // Step 1 → Step 2: Weiter-Button
        $('#brandner-wizard-next').on('click', function() {
            if (validateStep1()) {
                goToStep(2);
            }
        });

        // Step 2 → Step 1: Zurueck-Button
        $('#brandner-wizard-back-step2').on('click', function() {
            goToStep(1);
        });

        // Step 2 → Step 3: Weiter-Button
        $('#brandner-wizard-next-step2').on('click', function() {
            if (validateStep2()) {
                goToStep(3);
            }
        });

        // Step 3 → Step 2: Zurueck-Button
        $('#brandner-wizard-back-step3').on('click', function() {
            goToStep(2);
        });

        // Auto-Advance: Wenn Schritt 1 komplett, zu Schritt 2
        if (isStep1Complete()) {
            if (isStep2Complete()) {
                goToStep(3);
            } else {
                goToStep(2);
            }
        }
    }

    function goToStep(step) {
        currentStep = step;

        // Panels wechseln
        $('.brandner-wizard-panel').hide();
        $('.brandner-wizard-panel[data-wizard-step="' + step + '"]').show();

        // Status-Meldungen ausblenden
        $('.brandner-wizard-panel-status').hide();

        // Progress-Indicator aktualisieren
        updateProgress(step);

        // Nach oben scrollen
        $('html, body').animate({
            scrollTop: $('#brandner-wizard-progress').offset().top - 20
        }, 300);
    }

    function updateProgress(activeStep) {
        $('.brandner-wizard-progress .brandner-wizard-step').each(function() {
            var stepNum = parseInt($(this).data('step'), 10);
            var $circle = $(this).find('.brandner-wizard-circle');

            $circle.removeClass('active completed');

            if (stepNum < activeStep) {
                $circle.addClass('completed');
            } else if (stepNum === activeStep) {
                $circle.addClass('active');
            }
        });

        // Verbindungslinien aktualisieren
        var $lines = $('.brandner-wizard-line');
        $lines.each(function(index) {
            if (index + 1 < activeStep) {
                $(this).addClass('completed');
            } else {
                $(this).removeClass('completed');
            }
        });
    }

    /**
     * Prueft ob alle Pflichtfelder in Schritt 1 ausgefuellt sind
     * (fuer Auto-Advance, keine Fehlermeldungen)
     */
    function isStep1Complete() {
        var fields = [
            'billing_first_name', 'billing_last_name',
            'billing_address_1', 'billing_postcode',
            'billing_city', 'billing_country'
        ];

        for (var i = 0; i < fields.length; i++) {
            if (!$('#' + fields[i]).val()) {
                return false;
            }
        }

        // PLZ-Format pruefen
        var country = $('#billing_country').val();
        var plz = $('#billing_postcode').val();
        if (country === 'DE' && !/^\d{5}$/.test(plz)) return false;
        if ((country === 'AT' || country === 'CH') && !/^\d{4}$/.test(plz)) return false;

        // EU-Ausland: Privatperson/Unternehmen gewaehlt + Firmendaten komplett
        if (customerTypeErrors(country).length > 0) return false;

        return true;
    }

    /**
     * Prueft ob Schritt 2 (Telefon) komplett ist
     * (fuer Auto-Advance, keine Fehlermeldungen)
     */
    function isStep2Complete() {
        if (!$('#billing_phone').val()) {
            return false;
        }

        // Telefon-Verifizierung pruefen
        if ($('#brandner_phone_verified').length && $('#brandner_phone_verified').val() !== '1') {
            return false;
        }

        return true;
    }

    /**
     * Validiert Schritt 1 mit Fehlermeldungen
     */
    function validateStep1() {
        var errors = [];
        var $firstError = null;

        var requiredFields = [
            { id: 'billing_first_name', label: 'Vorname' },
            { id: 'billing_last_name', label: 'Nachname' },
            { id: 'billing_address_1', label: 'Stra\u00dfe / Nr.' },
            { id: 'billing_postcode', label: 'PLZ' },
            { id: 'billing_city', label: 'Ort' },
            { id: 'billing_country', label: 'Land' }
        ];

        requiredFields.forEach(function(field) {
            var $field = $('#' + field.id);
            if (!$field.val()) {
                $field.addClass('brandner-field-error');
                errors.push('Bitte geben Sie ' + field.label + ' ein.');
                if (!$firstError) $firstError = $field;
            }
        });

        // PLZ-Format
        var country = $('#billing_country').val();
        var plz = $('#billing_postcode').val();
        if (plz) {
            if (country === 'DE' && !/^\d{5}$/.test(plz)) {
                $('#billing_postcode').addClass('brandner-field-error');
                errors.push('Bitte geben Sie eine g\u00fcltige deutsche Postleitzahl ein (5 Ziffern).');
                if (!$firstError) $firstError = $('#billing_postcode');
            } else if ((country === 'AT' || country === 'CH') && !/^\d{4}$/.test(plz)) {
                $('#billing_postcode').addClass('brandner-field-error');
                errors.push('Bitte geben Sie eine g\u00fcltige Postleitzahl ein (4 Ziffern).');
                if (!$firstError) $firstError = $('#billing_postcode');
            }
        }

        // EU-Ausland: Privatperson/Unternehmen, Unternehmen mit Firmenname + USt-IdNr.
        customerTypeErrors(country).forEach(function(err) {
            err.$field.addClass('brandner-field-error');
            errors.push(err.message);
            if (!$firstError) $firstError = err.$focus;
        });

        if (errors.length > 0) {
            showStatus(errors.join('<br>'), 'error');
            if ($firstError) {
                $firstError.focus();
            }
            return false;
        }

        return true;
    }

    /**
     * Validiert Schritt 2 (Telefon) mit Fehlermeldungen
     */
    function validateStep2() {
        var errors = [];
        var $firstError = null;

        // Telefonnummer pruefen
        if (!$('#billing_phone').val()) {
            errors.push('Bitte geben Sie Ihre Telefonnummer ein.');
            if (!$firstError) $firstError = $('#brandner_phone_display');
        }

        // Telefon-Verifizierung (nur wenn Feature aktiv)
        if ($('#brandner_phone_verified').length && $('#brandner_phone_verified').val() !== '1') {
            errors.push('Bitte verifizieren Sie Ihre Telefonnummer per SMS.');
            if (!$firstError) $firstError = $('#brandner-send-sms-btn');
        }

        if (errors.length > 0) {
            showStatus(errors.join('<br>'), 'error');
            if ($firstError) {
                $firstError.focus();
            }
            return false;
        }

        return true;
    }

    // =====================================================================
    // Echtzeit-Validierung
    // =====================================================================
    function initValidation() {
        // PLZ-Validierung bei Eingabe
        $('#billing_postcode').on('input', function() {
            validatePlz($(this));
        });

        // Pflichtfelder bei Blur validieren
        $('#brandner-profile-form input[required], #brandner-profile-form select[required]').on('blur', function() {
            var $field = $(this);
            if (!$field.val()) {
                $field.addClass('brandner-field-error');
            } else {
                $field.removeClass('brandner-field-error');
            }
        });

        // Fehler-Markierung bei Eingabe entfernen
        $('#brandner-profile-form input, #brandner-profile-form select').on('input change', function() {
            $(this).removeClass('brandner-field-error');
        });
    }

    function validatePlz($field) {
        var val = $field.val();
        var country = $('#billing_country').val();

        if (!val) return;

        var valid = true;
        if (country === 'DE' && val.length >= 5) {
            valid = /^\d{5}$/.test(val);
        } else if ((country === 'AT' || country === 'CH') && val.length >= 4) {
            valid = /^\d{4}$/.test(val);
        }

        if (valid) {
            $field.removeClass('brandner-field-error');
        } else {
            $field.addClass('brandner-field-error');
        }
    }

    // =====================================================================
    // Privatperson/Unternehmen + USt-IdNr.-Pflicht je nach Land
    // Bei Sitz im EU-Ausland waehlt der Kunde Privatperson oder Unternehmen.
    // Nur Unternehmen brauchen Firmenname + USt-IdNr. (innergemeinschaftliche
    // Lieferung), Privatpersonen zahlen deutsche USt. Drittland (z.B. CH) hat
    // keine EU-USt-IdNr. — Firmendaten bleiben dort optional.
    // EU-Laenderliste kommt aus data-eu-vat-countries am Feld (ohne DE).
    // =====================================================================
    function isEuAbroad(country) {
        var $vat = $('#billing_vat');
        if (!country || !$vat.length) return false;
        var euList = String($vat.data('euVatCountries') || '').split(',');
        return euList.indexOf(country) !== -1;
    }

    function getCustomerType() {
        return $('input[name="brandner_customer_type"]:checked').val() || '';
    }

    /**
     * Fehler zur Kundentyp-Auswahl (nur EU-Ausland)
     * @return {Array<{message: string, $field: jQuery, $focus: jQuery}>}
     */
    function customerTypeErrors(country) {
        var errors = [];
        if (!isEuAbroad(country)) return errors;

        var type = getCustomerType();
        if (!type) {
            errors.push({
                message: 'Bitte wählen Sie, ob Sie sich als Privatperson oder als Unternehmen registrieren.',
                $field: $('#brandner-customer-type'),
                $focus: $('input[name="brandner_customer_type"]').first()
            });
        } else if (type === 'business') {
            if (!$.trim($('#billing_company').val() || '')) {
                errors.push({
                    message: 'Bitte geben Sie den Firmennamen an.',
                    $field: $('#billing_company'),
                    $focus: $('#billing_company')
                });
            }
            if (!$.trim($('#billing_vat').val() || '')) {
                errors.push({
                    message: 'Bitte geben Sie Ihre USt-IdNr. an. Für Unternehmen mit Sitz im EU-Ausland ist sie erforderlich.',
                    $field: $('#billing_vat'),
                    $focus: $('#billing_vat')
                });
            }
        }
        return errors;
    }

    function initCustomerType() {
        var $country = $('#billing_country');
        var $vat = $('#billing_vat');
        var $company = $('#billing_company');
        if (!$country.length || !$vat.length) return;

        function updateCustomerType() {
            var euAbroad = isEuAbroad($country.val());
            var type = getCustomerType();
            var business = euAbroad && type === 'business';

            $('#brandner-customer-type-row').toggle(euAbroad);
            $('#brandner-customer-type-hint-private').toggle(euAbroad && type === 'private');
            $('#brandner-company-fields').toggle(!euAbroad || business);

            $vat.prop('required', business);
            $company.prop('required', business);
            $('#billing_vat_required').toggle(business);
            $('#billing_company_required').toggle(business);
            $('#billing_vat_hint').toggle(business);
            $('#brandner-firmendaten-label').text(business ? 'Firmendaten' : 'Firmendaten (optional)');

            if (type) {
                $('#brandner-customer-type').removeClass('brandner-field-error');
            }
            if (!business) {
                $vat.removeClass('brandner-field-error');
                $company.removeClass('brandner-field-error');
            }
        }

        $country.on('change', updateCustomerType);
        $('input[name="brandner_customer_type"]').on('change', updateCustomerType);
        updateCustomerType();
    }

    /**
     * Formular-Validierung vor Submit (Schritt 3 = final)
     */
    function validateForm() {
        var errors = [];
        var $firstError = null;
        var errorStep = null;

        // Pflichtfelder pruefen (alle, inkl. Schritt 1+2 — Sicherheit)
        var step1Fields = [
            { id: 'billing_first_name', label: 'Vorname' },
            { id: 'billing_last_name', label: 'Nachname' },
            { id: 'billing_address_1', label: 'Stra\u00dfe / Nr.' },
            { id: 'billing_postcode', label: 'PLZ' },
            { id: 'billing_city', label: 'Ort' },
            { id: 'billing_country', label: 'Land' }
        ];

        step1Fields.forEach(function(field) {
            var $field = $('#' + field.id);
            if (!$field.val()) {
                $field.addClass('brandner-field-error');
                errors.push('Bitte geben Sie ' + field.label + ' ein.');
                if (!$firstError) { $firstError = $field; errorStep = 1; }
            }
        });

        // PLZ-Format
        var country = $('#billing_country').val();
        var plz = $('#billing_postcode').val();
        if (plz) {
            if (country === 'DE' && !/^\d{5}$/.test(plz)) {
                $('#billing_postcode').addClass('brandner-field-error');
                errors.push('Bitte geben Sie eine g\u00fcltige deutsche Postleitzahl ein (5 Ziffern).');
                if (!$firstError) { $firstError = $('#billing_postcode'); errorStep = 1; }
            } else if ((country === 'AT' || country === 'CH') && !/^\d{4}$/.test(plz)) {
                $('#billing_postcode').addClass('brandner-field-error');
                errors.push('Bitte geben Sie eine g\u00fcltige Postleitzahl ein (4 Ziffern).');
                if (!$firstError) { $firstError = $('#billing_postcode'); errorStep = 1; }
            }
        }

        // EU-Ausland: Privatperson/Unternehmen, Unternehmen mit Firmenname + USt-IdNr.
        customerTypeErrors(country).forEach(function(err) {
            err.$field.addClass('brandner-field-error');
            errors.push(err.message);
            if (!$firstError) { $firstError = err.$focus; errorStep = 1; }
        });

        // Telefon (Step 2)
        if (!$('#billing_phone').val()) {
            errors.push('Bitte geben Sie Ihre Telefonnummer ein.');
            if (!$firstError) { $firstError = $('#brandner_phone_display'); errorStep = 2; }
        }

        // Telefon-Verifizierung (nur wenn Feature aktiv)
        if ($('#brandner_phone_verified').length && $('#brandner_phone_verified').val() !== '1') {
            errors.push('Bitte verifizieren Sie Ihre Telefonnummer per SMS.');
            if (!$firstError) { $firstError = $('#brandner-send-sms-btn'); errorStep = 2; }
        }

        // Datenschutz-Checkbox (Step 3)
        if (!$('#brandner_privacy').is(':checked')) {
            errors.push('Bitte akzeptieren Sie die Datenschutzerkl\u00e4rung.');
            if (!$firstError) { $firstError = $('#brandner_privacy'); errorStep = 3; }
        }

        // AGB (Step 3)
        if ($('#brandner_agb_accepted').val() !== '1') {
            errors.push('Bitte lesen und akzeptieren Sie die AGB.');
            if (!$firstError) { $firstError = $('#brandner-agb-btn'); errorStep = 3; }
        }

        return { errors: errors, firstError: $firstError, errorStep: errorStep };
    }

    // =====================================================================
    // AGB Modal
    // =====================================================================
    function initAgbModal() {
        // AGB-Button oeffnet Modal
        $('#brandner-agb-btn').on('click', function() {
            openAgbModal();
        });

        // Modal schliessen
        $('#brandner-agb-modal-close').on('click', closeAgbModal);
        $('#brandner-agb-modal').on('click', function(e) {
            if ($(e.target).is('#brandner-agb-modal')) {
                closeAgbModal();
            }
        });

        // ESC
        $(document).on('keydown.agbModal', function(e) {
            if (e.key === 'Escape' && $('#brandner-agb-modal').is(':visible')) {
                closeAgbModal();
            }
        });

        // Accept Button
        $('#brandner-agb-modal-accept').on('click', function() {
            if ($(this).hasClass('is-disabled')) {
                var $hint = $('#brandner-agb-modal-hint');
                $hint.addClass('brandner-hint-highlight');
                setTimeout(function() {
                    $hint.removeClass('brandner-hint-highlight');
                }, 1500);
                return;
            }
            acceptAgb();
        });
    }

    function openAgbModal() {
        var $accept = $('#brandner-agb-modal-accept');
        var $body = $('#brandner-agb-modal-body');
        var $hint = $('#brandner-agb-modal-hint');

        $accept.addClass('is-disabled');
        $hint.text('Bitte scrollen Sie bis zum Ende der AGB.');

        // fadeIn mit Callback - Scroll-Check erst nach vollstaendigem Layout
        $('#brandner-agb-modal').fadeIn(300, function() {
            var el = $body[0];

            // Pruefen ob Inhalt ueberhaupt scrollbar ist
            if (el.scrollHeight <= el.clientHeight) {
                // Inhalt passt komplett rein - sofort aktivieren
                $accept.removeClass('is-disabled');
                $hint.text('Sie k\u00f6nnen die AGB jetzt akzeptieren.');
                return;
            }

            // Scroll-Event: Button aktivieren wenn Bottom erreicht
            $body.off('scroll.agb').on('scroll.agb', function() {
                var scrollTop = el.scrollTop;
                var scrollHeight = el.scrollHeight;
                var clientHeight = el.clientHeight;
                // 20px Toleranz
                if (scrollTop + clientHeight >= scrollHeight - 20) {
                    $accept.removeClass('is-disabled');
                    $hint.text('Sie k\u00f6nnen die AGB jetzt akzeptieren.');
                    $body.off('scroll.agb');
                }
            });
        });

        $('body').css('overflow', 'hidden');
    }

    function closeAgbModal() {
        $('#brandner-agb-modal').fadeOut(200);
        $('body').css('overflow', '');
        $('#brandner-agb-modal-body').off('scroll.agb');
    }

    function acceptAgb() {
        agbAccepted = true;
        $('#brandner_agb_accepted').val('1');

        // Status aktualisieren
        $('#brandner-agb-status').html(
            '<span class="brandner-agb-accepted">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            ' AGB akzeptiert' +
            '</span>'
        );

        closeAgbModal();
    }

    // =====================================================================
    // AJAX Submit
    // =====================================================================
    function initFormSubmit() {
        $('#brandner-profile-form').on('submit', function(e) {
            e.preventDefault();

            var validation = validateForm();
            if (validation.errors.length > 0) {
                // Zum richtigen Step wechseln falls Fehler dort liegt
                if (validation.errorStep && validation.errorStep !== currentStep) {
                    goToStep(validation.errorStep);
                }
                showStatus(validation.errors.join('<br>'), 'error');
                if (validation.firstError) {
                    validation.firstError.focus();
                }
                return;
            }

            var $btn = $('#brandner-profile-submit-btn');
            var $status = $('#brandner-profile-status');

            $btn.prop('disabled', true).text(config.i18n?.saving || 'Wird gespeichert...');
            $status.hide();

            $.ajax({
                type: 'POST',
                url: config.ajaxUrl,
                data: $('#brandner-profile-form').serialize(),
                dataType: 'json',
                success: function(response) {
                    $btn.prop('disabled', false).text('Registrierung abschlie\u00dfen');

                    if (response.success) {
                        showSuccessPopup();
                    } else {
                        showStatus(response.data?.message || config.i18n?.error || 'Ein Fehler ist aufgetreten.', 'error');
                    }
                },
                error: function() {
                    $btn.prop('disabled', false).text('Registrierung abschlie\u00dfen');
                    showStatus(config.i18n?.error || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.', 'error');
                }
            });
        });
    }

    function showStatus(message, type) {
        // Status im aktiven Panel anzeigen
        var $status;
        if (currentStep === 1) {
            $status = $('#brandner-profile-status-step1');
        } else if (currentStep === 2) {
            $status = $('#brandner-profile-status-step2');
        } else {
            $status = $('#brandner-profile-status');
        }

        $status.html(message)
               .removeClass('brandner-status-success brandner-status-error')
               .addClass(type === 'error' ? 'brandner-status-error' : 'brandner-status-success')
               .slideDown(200);

        // Zum Status scrollen
        $('html, body').animate({ scrollTop: $status.offset().top - 100 }, 300);
    }

    function showSuccessPopup() {
        $('#brandner-profile-success').fadeIn(300);
        $('body').css('overflow', 'hidden');

        // Auto-Redirect nach 3 Sekunden
        var redirectUrl = config.auctionsUrl || $('#brandner-profile-success-link').attr('href');
        if (redirectUrl) {
            setTimeout(function() {
                window.location.href = redirectUrl;
            }, 3000);
        }
    }

    // =====================================================================
    // Init
    // =====================================================================
    $(document).ready(function() {
        initPhoneSync();
        initWizard();
        initValidation();
        initCustomerType();
        initAgbModal();
        initFormSubmit();
    });

})(jQuery);
